import React from "react";
import { connect } from "react-redux";

import { EntityType } from "@mapmycustomers/shared/enum";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { RegularSavedFilter } from "@mapmycustomers/shared/types/viewModel/SavedFilter";

import {
  DealStatusFilter,
  FrequencyStatusFilter,
  NearbyFilter,
  NextActivityFilter,
  NoLocationFilter,
  NoRecentContactFilter,
  RecentlyAddedFilter,
} from "@app/component/filtering";
import FrequencyFilter from "@app/component/filtering/components/FrequencyFilter";
import QuickFilterBar from "@app/component/QuickFilterBar";
import useView from "@app/component/view/utils/useView";
import { setOfferedFilters } from "@app/scene/deal/store/actions";
import { RootState } from "@app/store/rootReducer";
import { getFavoriteSavedFilters } from "@app/store/savedFilters";

interface Props {
  favoriteSavedFilters: RegularSavedFilter[];
  implicitFilterFields?: IField[];
  onSetCustomFilters: typeof setOfferedFilters;
}

const DealListQuickFilters: React.FC<Props> = ({
  favoriteSavedFilters,
  implicitFilterFields,
  onSetCustomFilters,
}) => {
  const {
    updateFilterModel,
    viewState: { filter },
  } = useView();

  return (
    <QuickFilterBar implicitFilterFields={implicitFilterFields} savedFilters={favoriteSavedFilters}>
      <NearbyFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <NoRecentContactFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <FrequencyFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <FrequencyStatusFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <RecentlyAddedFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <NextActivityFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <DealStatusFilter
        filter={filter}
        onSetCustomFilters={onSetCustomFilters}
        onUpdateFilterModel={updateFilterModel}
      />
      <NoLocationFilter filter={filter} onUpdateFilterModel={updateFilterModel} />
    </QuickFilterBar>
  );
};

const mapStateToProps = (state: RootState) => ({
  favoriteSavedFilters: getFavoriteSavedFilters(state)(EntityType.DEAL) as RegularSavedFilter[],
});

const mapDispatchToProps = {
  onSetCustomFilters: setOfferedFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealListQuickFilters);
